import { createContext } from 'react'
import { type PurchasesStoreProduct, type PurchasesSubscriptionInfo } from 'react-native-purchases'

export type RevenueCatContextValue = {
  isPlus: boolean | null
  product: PurchasesStoreProduct | null
  subscription: PurchasesSubscriptionInfo | null
}
export const RevenueCatContext = createContext<RevenueCatContextValue>({
  isPlus: null,
  product: null,
  subscription: null
})
